import React, { useEffect, useState, useMemo } from "react";
import "../styles/patientsView.scss";
import { useSelector, useDispatch } from "react-redux";
import { sidebar, patientid, updatePatientTab, CRUDRecordPopup } from "../Redux/Slice/rootSlice";
import {
  fetchSpecificPatient,
  getPrescriptionHistory,
} from "../Redux/Thunk/Actions";
import profileimage from "../assets/images/patient.png";
import noImage from "../assets/images/no-photo-available-icon-4.jpg";
import BasicTable from "../Components/Global_Components/reacttable/table";
import PatientPrescriptionHistory from "./patientPrescriptionHistory";
import PrescriptionType_PopUp from "../Components/PrescriptionType_PopUp";
import PatientRecords from "../Components/PatientRecords";
import TemplateSelect from "../Components/template_selectform";
import PatientReports from "./PatientReports";
import RecordCRUD from "../Components/RecordCRUD";
import AddRecordCRUD from "../Components/AddRecordCRUD";
// import ""
function PatientsView(props) {
  const sideActive = useSelector((state) => state.counter.sidebarnav);
  const patientId = useSelector((state) => state.counter.patientid);
  const patientData = useSelector((state) => state.counter.patientsData);
  const prescriptionId = useSelector((state) => state.counter.prescriptionId);
  const userdata = useSelector(state=>state.counter.userdata)
  const [finalPatientsData, setFinalPatientsData] = useState("");
  const activeTab = useSelector((state) => state.counter.patientTab);
  const [typePrescriptionPopUp, setTypePrescriptionPopUp] = useState(false);
  let recordpopup = useSelector((state) => state.counter.recordpopup);  
  const [recordCRUDpopup, setRecordCRUDpopup] = useState(recordpopup);
  const [dataPatientRecord, setDataPatientRecord] = useState(false);
 
  const [typeTemplatePopUp, setTypeTemplatePopUp] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      props.loaderchange("true");
      const addPatient = fetchSpecificPatient(patientId);
      const response = await dispatch(addPatient);
      if (response.payload?.status?.code === 200) {
        console.log(response.payload.data, "jfalskdfjlasjldfjlajslfjalsj");
        setFinalPatientsData(response.payload.data);
        props.loaderchange("false");
      }
      return;
    };

    fetchData();
  }, []);
  const previousPageUrl = document.referrer;

  // console.log(`Previously visited page URL: ${previousPageUrl}`);

  const handleTabClick = (e) => {
    dispatch(updatePatientTab(e.target.innerText));
  };
  const handleAddPrescription = () => {
    setTypePrescriptionPopUp(!typePrescriptionPopUp);
  };
  const handleAddTemplates = () => {
    setTypeTemplatePopUp(!typeTemplatePopUp);
  };

  const handleAddRecord = (e) => {
    // console.log(props);
    // return
    dispatch(CRUDRecordPopup(true));
    setRecordCRUDpopup(true);
  };
  return (
    <div className={sideActive ? "patient-view-sa" : "patient-view"}>
      {typePrescriptionPopUp && (
        <PrescriptionType_PopUp
          setTypePrescriptionPopUp={setTypePrescriptionPopUp}
        />
      )}
      {typeTemplatePopUp && (
        <TemplateSelect
          setTypeTemplatePopUp={setTypeTemplatePopUp}
        />
      )}
      {recordCRUDpopup && (
          <AddRecordCRUD
            setclosepopup={setRecordCRUDpopup}
            loaderchange={props.loaderchange}
            patientData={finalPatientsData}
            patientid_share={patientId}
            datareload={setDataPatientRecord}
            currentdatareload={dataPatientRecord}
          />
        )}
      <div className="pageWrapper">
        <div className="content container-fluid">
          {/* Page Header Start */}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Profile</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="/"
                      style={{ textDecoration: "none", color: "black" }}
                      onClick={(e) => {
                        dispatch(sidebar("DashBoard"));
                      }}
                    >
                      Dashboard
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    <a
                      href="/Patients"
                      onClick={() => {
                        dispatch(updatePatientTab("History"));
                      }}
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      Patient
                    </a>
                  </li>
                  <li className="breadcrumb-item active">Profile</li>
                </ul>
              </div>
            </div>
          </div>
          {/* Page Header End */}

          <div className="pageBody" style={{ width: "100%" }}>
            {/* Page Body Start */}
            <div className="row">
              {/* <div className="col-md-12"></div> */}
              <div className="col-lg-12">
                <div className="card">
                  <div className="profile-header">
                    <div className="row align-items-center">
                      <div className="col-auto profile-image">
                        <a>
                          <img
                            className=""
                            alt="User Image"
                            style={{ borderRadius: "50%" }}
                            src={profileimage}
                          // src={patientsrc ? patientsrc : noimage}
                          />
                        </a>
                      </div>
                      <div className="col ml-md-n2 profile-user-info">
                        <h4 className="user-name mb-0">
                          {finalPatientsData.titles !==undefined?finalPatientsData?.titles +
                            " " +
                            finalPatientsData?.first_name +
                            " " +
                            finalPatientsData?.last_name:""}

                        </h4>
                        <h6 className="text-muted">
                          {fetchSpecificPatient.gmail}
                        </h6>
                      </div>
                      <div className="col-auto profile-btn"></div>
                    </div>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title d-flex justify-content-between">
                      <span>Personal Details</span>
                    </h5>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Name :
                      </p>
                      <p className="col-sm-10">
                        {finalPatientsData.titles +
                          " " +
                          finalPatientsData.first_name +
                          " " +
                          finalPatientsData.last_name}
                      </p>
                    </div>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Unique ID :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.p_uhid}</p>
                    </div>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Email ID :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.email}</p>
                    </div>
                    {/* <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        DOB :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.birthdate}</p>
                    </div> */}
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Age :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.age}</p>
                    </div>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Mobile :
                      </p>
                      <p className="col-sm-10">
                        {finalPatientsData.phonenumber}
                      </p>
                    </div>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Blood Group
                      </p>
                      {/* <p className="col-sm-10">{creatphoneno}</p> */}
                      <p className="col-sm-9">
                        {finalPatientsData.blood_group}
                      </p>
                    </div>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Gender :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.gender}</p>
                    </div>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Referral :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.doctor_id}</p>
                    </div>
                    {finalPatientsData.doctor_id==="Doctor" && (
                      <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Doctor Referred :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.doctor_name}</p>
                    </div>
                    )}
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Purpose :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.purpose}</p>
                    </div>


                    {/* <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Referral Doc Name :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.doctor_name}</p>
                    </div>
                    <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                        Referral Doc No. :
                      </p>
                      <p className="col-sm-10">{finalPatientsData.doctor_no}</p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {userdata.role !== "Lab" && (<div className="row" style={{ justifyContent: "flex-end" }}>
            <div className="buttonHeader">
              <button
                className="addPatientRecordbtn"
                style={{ marginRight: "10px" }}
                // onClick={handleAddPrescription}
                onClick={(e) => {
                  handleAddRecord(e);
                }}
              >
                Add Report
              </button>
              <button
                className="addPatientRecordbtn"
                onClick={handleAddTemplates}
              >
                Add Templates
              </button>
            </div>
          </div>)}
          <div className="profile-menu">
            <ul
              className="nav nav-tabs"
              role="tablist"
              style={{ border: "none" }}
            >
              {" "}
              <button
                className={`nav-link${activeTab == "History" ? " active" : ""
                  } about`}
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                onClick={(e) => handleTabClick(e)}
                style={{ marginRight: "10px" }}
              >
                History
              </button>
              {/* <button
                className={`nav-link${
                  activeTab == "Patients Records" ? " active" : ""
                } basetime`}
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="false"
                href="#password_tab"
                onClick={(e) => handleTabClick(e)}
                style={{ marginRight: "10px" }}
              >
                Patients Records
              </button> */}
              <button
                className={`nav-link${activeTab == "Billing" ? " active" : ""
                  } bills`}
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="false"
                href="#password_tab"
                onClick={(e) => handleTabClick(e)}
                style={{ marginRight: "10px" }}
              >
                Billing
              </button>
              <button
                className={`nav-link${activeTab == "Patient Reports" ? " active" : ""
                  } repor`}
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="false"
                href="#password_tab"
                onClick={(e) => handleTabClick(e)}
                style={{ marginRight: "10px" }}
              >
                Patient Reports
              </button>
            </ul>
            {activeTab === "History" ? (
              <PatientPrescriptionHistory
                loaderchange={props.loaderchange}
                patientId={patientId}
                popupalert={props.popupalert}
              />
            ) : null}

            {activeTab === "Patient Reports" ? (
              <PatientRecords
                loaderchange={props.loaderchange}
                patientId={patientId}
                popupalert={props.popupalert}

              />
            ) : null}

            {/* {activeTab === "Patients Records" ? (
              <PatientRecords
                loaderchange={props.loaderchange}
                patientId={patientId}
                typeshow={"all"}
              />
            ) : null} */}

            {activeTab === "Billing" ? (
              <PatientRecords
                loaderchange={props.loaderchange}
                patientId={patientId}
                popupalert={props.popupalert}
                popuptext={props.popuptext}
              // typeshow={"all"}
              />
            ) : null}
          </div>
          {/* Page Body End */}
        </div>
      </div>
    </div>
  );
}

export default PatientsView;
